import React from 'react';

interface Props {
  children: any;
  text: string;
}

export const Tooltip = ({ children, text }: Props) => {
  return (
    <div data-tooltip-id="tooltip" data-tooltip-content={text}>
      {children}
    </div>
  );
};
